import React, { FC, useContext, useMemo, useState } from 'react';

import FormulaEditorToolbarIcon from '../../components/FormulaEditorToolbarIcon';

//constants
import ICONS from '../../../../../../constants/icons';

// contexts
import { EditorContext } from '../../../../../../context/EditorContext';

// components
import DatasetConfigurationalModalV1 from './DatasetConfigurationalModalV1';

interface DatasetConfigurationalMainProps {
    isEditable: boolean;
}

const DatasetConfigurationalMain: FC<DatasetConfigurationalMainProps> = ({
    isEditable,
}) => {
    const [
        showDatasetConfigurationalModal,
        setShowDatasetConfigurationalModal,
    ] = useState<boolean>(false);
    const {
        editorDetails: { formula },
    } = useContext(EditorContext);

    const isDisabled = useMemo<boolean>(() => {
        /**
         * Determines if a component should be disabled.
         *
         * The component is disabled based on the following conditions:
         * - If `isEditable` is `false` (i.e., the message is not in draft mode), the component
         *   is disabled unless `formula?.dataset_id` exists.
         * - If `isEditable` is `true` (i.e., the message is in draft mode), the component
         *   is disabled unless `formula?.id` exists.
         */
        return !isEditable ? !formula?.dataset_id : !formula?.id!;
    }, [isEditable, formula]);

    return (
        <>
            <FormulaEditorToolbarIcon
                isDisabled={isDisabled}
                Icon={ICONS.datasets}
                title="Select dataset"
                onIconClick={() => setShowDatasetConfigurationalModal(true)}
            />
            {showDatasetConfigurationalModal && (
                <DatasetConfigurationalModalV1
                    isEditable={isEditable}
                    handleClose={() =>
                        setShowDatasetConfigurationalModal(false)
                    }
                />
            )}
        </>
    );
};

export default DatasetConfigurationalMain;
